import { useRef, useState } from "react";

import { TicketingFormCategory } from "@simplyk/common";

import { useRateContext } from "../../../../Context/RateContext";

export const useConfirmTaxChange = () => {
  const { formCategory, hasExistingPayments, canModifyRenewalAmount, unlockRenewalAmount } = useRateContext();
  const requiresConfirmation = formCategory === TicketingFormCategory.MembershipV2 && hasExistingPayments;

  const isConfirmed = !requiresConfirmation || canModifyRenewalAmount;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const pendingChangeRef = useRef<(() => void) | null>(null);

  const runAfterConfirmation = (change: () => void) => {
    if (isConfirmed) {
      change();
      return;
    }
    pendingChangeRef.current = change;
    setIsDialogOpen(true);
  };

  const confirm = () => {
    unlockRenewalAmount();
    setIsDialogOpen(false);
    pendingChangeRef.current?.();
    pendingChangeRef.current = null;
  };

  const cancel = () => {
    pendingChangeRef.current = null;
    setIsDialogOpen(false);
  };

  return { isConfirmed, isDialogOpen, runAfterConfirmation, confirm, cancel };
};
